<div class="row g-0">
  <div class="col-lg-5 col-xxl-3 d-flex">
    <select class="form-select ">
      <option>Mostrar 10</option>
    </select>
    <span class="results my-auto mx-4">57 resultados</span>
  </div>
  <div
    class="col-lg-7 col-xxl-9 d-flex justify-content-end size-14px pages mt-4 mt-lg-0 justify-content-center justify-content-lg-end">

    <a [routerLink]="[]" class="footer-page">
      <i class="bi bi-chevron-left"></i>
    </a>

    <a [routerLink]="[]" class="footer-page">1</a>
    <a [routerLink]="[]" class="footer-page">2</a>
    <a [routerLink]="[]" class="footer-page">3</a>

    <a [routerLink]="[]" class="footer-page">
      <i class="bi bi-three-dots"></i>
    </a>

    <a [routerLink]="[]" class="footer-page">
      <i class="bi bi-chevron-right"></i>
    </a>
  </div>
</div>
